import { getEmbeddedReportServiceUrl } from './utils';

export const getAvailableEmbeddedReportsQuery = async () => {
    const path = '/available';
    const url = `${getEmbeddedReportServiceUrl()}${path}`;
    return { url };
};

export const getEmbeddedReportUrlQuery = async (resourceIdentifier) => {
    const path = `/embed/${resourceIdentifier}`;
    const url = `${getEmbeddedReportServiceUrl()}${path}`;
    return { url };
};
